import styled from "styled-components";

export const Container = styled.div`
  width: 208px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
`

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
`

export const CardItem = styled.div`
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  cursor: pointer;

  .cardItemIcon {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  .cardItemText {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 6px;
  }

  &:hover {
    background-color: ${({theme}) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }
`
